import { VerbConjugation } from "../VerbConjugationModel";

export class ConjugationTableData {
  constructor(
    public title: string,                          
    public verbs: VerbConjugation[]                
  ) {}
}
